import { render, staticRenderFns } from "./FloorAreaBedroom.vue?vue&type=template&id=be15aee6&"
import script from "./FloorAreaBedroom.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaBedroom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports